import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";

const TabNavigator = ({
  tabs = [],
  children,
  defaultActiveKey,
  nav_wrapper_class,
  setActiveTab = null,
  small = false,
}) => {
  const [activeKey, setActiveKey] = useState("");

  const handleClick = (key) => {
    setActiveKey(key);
    if (setActiveTab) {
      setActiveTab(key);
    }
  };

  useEffect(() => {
    setActiveKey(defaultActiveKey);
  }, [defaultActiveKey]);

  return (
    <>
      <Tab.Container activeKey={activeKey} onSelect={handleClick}>
        <div className={nav_wrapper_class}>
          <Nav variant="pills" className="tabfull">
            {tabs?.map((item) => (
              <Nav.Item className={small ? "small-tab" : ""} key={item?.key}>
                <Nav.Link eventKey={item?.key}>
                  {item?.title}
                  {item?.count && <span className="numbercount">{item.count}</span>}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          {children}
        </div>
      </Tab.Container>
    </>
  );
};

export default TabNavigator;
